import $ from 'jquery';
import {smoothy} from "../../Libraries/smoothy";

function setupResultsEvents() {

    $('.js-lfmpublist-open').off('click').on('click', ev => {
        ev.preventDefault();
        const $item = $(ev.currentTarget).closest('.lfmpub-list__item');
        $item.toggleClass('open');
        if (!$item.hasClass('open')) {
            smoothy(() => Math.max(0, $item.offset().top - $(window).height() * .25), 700);
        }
    });

    setupPaginationEvents();
}

function setupPaginationEvents() {
    $('#lfmpub-results-grid').find('.page-link[data-page]').off('click').on('click', ev => {
        ev.preventDefault();
        const page = $(ev.currentTarget).data('page');
        $('.js-lfmpubfilter-page').val(page);
        currentMode = 'filter';
        $('.js-lfmpubfilter-form').trigger('submit');
    });
}

setupResultsEvents();

const EXPORT_EXTENSIONS = {
    'export-bibtex': 'bib',
    'export-ris':    'ris',
    'export-fis':    'csv',
};

/**
 * Extract a filename from a Content-Disposition response header. Falls back
 * to a sensible default derived from the export mode if the header is
 * missing (e.g. some proxies strip it).
 */
function filenameFromResponse(resp, mode) {
    const cd = resp.headers.get('Content-Disposition') || '';
    // Match: filename="something.bib" or filename=something.ris
    const m = cd.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);
    if (m && m[1]) {
        try {
            return decodeURIComponent(m[1]);
        } catch (e) {
            return m[1];
        }
    }
    const ext = EXPORT_EXTENSIONS[mode] || 'txt';
    return 'lfmpublications-export.' + ext;
}

let currentMode = 'filter';

$('.js-lfmpubfilter-form button[name=mode]').on('click', ev => {
    currentMode = $(ev.currentTarget).attr('value');
    // Reset page to 1 when applying a new filter
    $('.js-lfmpubfilter-page').val(1);
});

$('.js-lfmpubfilter-form').off('submit').on('submit', ev => {
    ev.preventDefault();
    const $form = $(ev.currentTarget);

    let url = new URL(location.href);
    let simUser = null;
    if (url.searchParams.has('ADMCMD_simUser')) {
        simUser = url.searchParams.get('ADMCMD_simUser');
    }

    url.search = '';

    if (simUser !== null) {
        url.searchParams.append('ADMCMD_simUser', simUser);
    }

    let types = [];
    $form.serializeArray().forEach(item => {
        if (item.name === 'typen') {
            if (item.value) {
                types.push(item.value);
            }
        } else if (item.name === 'page') {
            if (item.value && item.value !== '1') {
                url.searchParams.append('page', item.value);
            }
        } else if (item.value) {
            url.searchParams.append(item.name, item.value);
        }
    });
    if (types.length > 0) {
        url.searchParams.append('typen', types.join(','));
    }

    const $currentFilter = $('#lfmpub-filter-grid');
    const $currentResults = $('#lfmpub-results-grid');

    $currentFilter.addClass('non-interactive');
    $currentResults.addClass('non-interactive');

    (async () => {

        let html = '';
        try {
            history.pushState({}, '', url);
            url.searchParams.append('mode', currentMode);
            let resp = await fetch(url);
            if (currentMode.startsWith('export')) {
                if (resp.status === 200) {
                    let blob = await resp.blob();
                    const blobUrl = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = blobUrl;
                    a.download = filenameFromResponse(resp, currentMode);
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(blobUrl);

                    $currentFilter.removeClass('non-interactive');
                    $currentResults.removeClass('non-interactive');
                    return;
                } else {
                    html = await resp.text();
                }
            } else {
                html = await resp.text();
            }
        } catch (e) {
            $currentFilter.removeClass('non-interactive');
            $currentResults.removeClass('non-interactive');
            return;
        }

        const $html = $(html);
        const $results = $html.find('#lfmpub-results-grid').first();

        if ($results.length === 1) {
            $currentResults.replaceWith($results);
            setupResultsEvents();
        } else {
            $currentResults.removeClass('non-interactive');
        }

        $currentFilter.removeClass('non-interactive');

    })();
});

